import { render, staticRenderFns } from "./ManualForm.vue?vue&type=template&id=54320c4e&"
import script from "./ManualForm.vue?vue&type=script&lang=ts&"
export * from "./ManualForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports